import React, { useState } from 'react';

//Assets and Css
import { Workbody, Left, Right, Project1, Screen, BottomMenu, Video, Tabs, LINKBAR, VLC } from './Styled';
import Workicon from '../../Assets/Workicon.svg'
import { FaRegSquare } from "react-icons/fa6";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoIosArrowBack } from "react-icons/io";

//Utils
import { Worklist } from '../../Components/Utils';

const Index = () => {

    const [activeData, setActiveData] = useState(Worklist[0].link);
    const [activeVideo, setActiveVideo] = useState(Worklist[0].video_src);

    return (
        <Workbody>
            <Left>
                <h1><span>Ui Design &</span> Projects</h1>
                <img src={Workicon} />
            </Left>
            <Right>
                <Screen>
                    <Tabs>
                        {Worklist?.map((data, id) => (
                            // <a href={data.link} target='_blank'>
                            <Project1 key={id} pstyle={data?.pstyle} onClick={() => { setActiveData(data?.link); setActiveVideo(data?.video_src) }}>
                                <img src={data.img} />
                            </Project1>
                        ))}
                    </Tabs>
                    <Video>
                        <LINKBAR> <a href={activeData} target='_blank'>{activeData} </a>  </LINKBAR>
                        <VLC>
                            <video className="video-player" controls
                                autoPlay
                                loop
                                muted
                                key={activeVideo}
                            >
                                <source src={activeVideo} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>

                        </VLC>
                    </Video>
                    <BottomMenu>
                        <GiHamburgerMenu />
                        <FaRegSquare />
                        <IoIosArrowBack />
                    </BottomMenu>
                </Screen>

            </Right>
        </Workbody>
    );
}

export default Index;
